module.exports = __webpack_public_path__ + "static/media/logo-footer.d57e4308.svg";